export default __webpack_public_path__ + "static/logo-circle-89abf464500f6b262cee2dea7a8344d2.jpg";